<template>
  <div>
    <b-table-lite 
      striped 
      outlined 
      hover 
      :fields="fields" 
      :items="items" 
      :tbody-tr-class="rowClass"
      thead-class="table_header" />
  </div>
</template>

<script>
export default {

  name: 'PropertyTypeTable',

  data() {
    return {
      items: [],
      fields: [
        { key: 'val', label: 'Property Type' },
        { key: 'pct', label: 'Percentage of Households' },
        { key: 'hh', label: 'Households' }
      ]
    }
  },

  props: {
    profiledata: {
      type: Object,
      default: null
    }
  },

  methods: {
    rowClass() {
      return 'table-sm'
    }
  },

  mounted() {
    this.items = [
      {
        val: 'Apartment',
        pct: this.profiledata.propertyTypeApartmentPct.toFixed(1) + "%",
        hh: this.profiledata.propertyTypeApartmentHh
      },{
        val: 'Condo',
        pct: this.profiledata.propertyTypeCondoPct.toFixed(1) + "%",
        hh: this.profiledata.propertyTypeCondoHh
      },{
        val: 'Multi-Family',
        pct: this.profiledata.propertyTypeMultiFamilyPct.toFixed(1) + "%",
        hh: this.profiledata.propertyTypeMultiFamilyHh
      },{
        val: 'PO Box',
        pct: this.profiledata.propertyTypePoBoxPct.toFixed(1) + "%",
        hh: this.profiledata.propertyTypePoBoxHh
      },{
        val: 'Rural',
        pct: this.profiledata.propertyTypeRuralPct.toFixed(1) + "%",
        hh: this.profiledata.propertyTypeRuralHh
      },{
        val: 'Single Family',
        pct: this.profiledata.propertyTypeSingleFamilyPct.toFixed(1) + "%",
        hh: this.profiledata.propertyTypeSingleFamilyHh
      },{
        val: 'Trailer',
        pct: this.profiledata.propertyTypeTrailerPct.toFixed(1) + "%",
        hh: this.profiledata.propertyTypeTrailerHh
      }
    ];
  }
}
</script>
